import { c as _c } from "react/compiler-runtime";
import { CommaList } from '@/components/Atoms/CommaList/CommaList';
import useTranslation from '@/hooks/useTranslation';
import type { Country } from 'bnef';
import type { FC } from 'react';
export const CountryUpdates: FC<{
  updates?: Record<string, number>;
  country: Country;
}> = t0 => {
  const $ = _c(8);
  const {
    updates,
    country
  } = t0;
  if (!updates) {
    return null;
  }
  let t1;
  if ($[0] !== updates) {
    t1 = Object.keys(updates);
    $[0] = updates;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== country || $[3] !== t1 || $[4] !== updates) {
    t2 = t1.map(updateKey => <li key={updateKey}><Update country={country} updateKey={updateKey} count={updates[updateKey]} /></li>).filter(Boolean);
    $[2] = country;
    $[3] = t1;
    $[4] = updates;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const items = t2;
  if (!items.length) {
    return null;
  }
  let t3;
  if ($[6] !== items) {
    t3 = <CommaList animate={true}>{items}</CommaList>;
    $[6] = items;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
const Update: FC<{
  updateKey: string;
  count: number;
  country: Country;
}> = t0 => {
  const $ = _c(17);
  const {
    updateKey,
    count,
    country
  } = t0;
  const {
    t
  } = useTranslation();
  switch (updateKey) {
    case "power_market_structure":
      {
        const t1 = `${country.url}/power#power-market-structure`;
        let t2;
        if ($[0] !== t) {
          t2 = t("common:CountryUpdates.power_market_structure_diagram");
          $[0] = t;
          $[1] = t2;
        } else {
          t2 = $[1];
        }
        let t3;
        if ($[2] !== t1 || $[3] !== t2) {
          t3 = <a href={t1}>{t2}</a>;
          $[2] = t1;
          $[3] = t2;
          $[4] = t3;
        } else {
          t3 = $[4];
        }
        return t3;
      }
    case "policy_key_dates":
      {
        const t1 = `${country.url}/power#policies`;
        let t2;
        if ($[5] !== count || $[6] !== t) {
          t2 = count === 1 ? t("common:CountryUpdates.one_policy_updated") : t("common:CountryUpdates.many_policies_updated", {
            number: count
          });
          $[5] = count;
          $[6] = t;
          $[7] = t2;
        } else {
          t2 = $[7];
        }
        let t3;
        if ($[8] !== t1 || $[9] !== t2) {
          t3 = <a href={t1}>{t2}</a>;
          $[8] = t1;
          $[9] = t2;
          $[10] = t3;
        } else {
          t3 = $[10];
        }
        return t3;
      }
    case "new_policy":
      {
        const t1 = `${country.url}/power#policies`;
        let t2;
        if ($[11] !== count || $[12] !== t) {
          t2 = count === 1 ? t("common:CountryUpdates.one_policy_new") : t("common:CountryUpdates.many_policies_new", {
            number: count
          });
          $[11] = count;
          $[12] = t;
          $[13] = t2;
        } else {
          t2 = $[13];
        }
        let t3;
        if ($[14] !== t1 || $[15] !== t2) {
          t3 = <a href={t1}>{t2}</a>;
          $[14] = t1;
          $[15] = t2;
          $[16] = t3;
        } else {
          t3 = $[16];
        }
        return t3;
      }
    default:
      {
        return null;
      }
  }
};